export type Dp = string;

export const DpValues = {
  DP01: '0px',
  DP02: '2px',
  DP03: '4px',
  DP04: '8px',
  DP05: '12px',
  DP06: '16px',
  DP07: '20px',
  DP08: '24px',
  DP09: '28px',
  DP10: '32px',
  DP11: '36px',
  DP12: '40px',
  DP13: '44px',
  DP14: '48px',
  DP15: '52px',
  DP16: '56px',
  DP17: '60px',
  DP18: '64px',
  DP19: '68px',
  DP20: '72px'
};
